import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { JJamesInputComponent, JjamesButtonComponent } from "shared-lib";
import { BillingAddressDto } from '../../../api/gen';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-billing-address',
  imports: [CommonModule, MatIconModule, JJamesInputComponent, JjamesButtonComponent, TranslatePipe],
  templateUrl: './billing-address.component.html',
  styleUrl: './billing-address.component.scss'
})
export class BillingAddressComponent {

  @Input() billingAddress: BillingAddressDto | null = null;
}
